import '../../../sass/components/list/card/mobile_example.scss';
import '../../../sass/pages/landing/infowebsitehelp.scss';

const promoVideoAd = document.querySelector('.videoPromo');

if (promoVideoAd) {
  promoVideoAd.addEventListener('click', () => {
    triggerYouTubePromo(promoVideoAd);
    promoVideoAd.classList.add('revealVideo');
  });
}

function triggerYouTubePromo(card) {
  const video = card.querySelector('iframe');
  const videoSource = video.src;
  return (video.src = `${videoSource}&autoplay=1`);
}
